import { atom } from "jotai";

export const callPanelOpenAtom = atom<boolean>(false);
export const dailyErrorAtom = atom<string | null>(null);
export const confirmationOpenAtom = atom<boolean>(false);
export const translatorIdAtom = atom<string | null>(null);
export const isDialingTranslatorAtom = atom<boolean>(false);
export const videoCallRoomTokenAtom = atom<string | null>(null);
export const confirmationModalOpenAtom = atom<boolean>(false);
